<template>
	<!--
	<div
		class="container padding-top-lg-2 padding-bottom-xs-2 padding-bottom-lg-0"
	>
    -->
	<div class="container padding-top-xs-2 padding-bottom-xs-2">
		<div class="row">
			<div class="col-xs-12">
				<div class="row">
					<div class="col-xs-12 col-lg-6">
						<div class="search-activity">
							<input
								type="text"
								class="search-activity-input"
								:class="{
									'nk-force-disable': loading.doingBooking,
								}"
								name="search-activity"
								placeholder="Sök behandling eller konsultation"
								v-model="searchQuery"
								@keyup="handleActivitySearch"
							/>
							<a
								href="#"
								class="clear-search-query link-close-right"
								v-if="searchQuery"
								@click.prevent="clearSearchQuery"
							></a>
						</div>
					</div>
				</div>
				<div
					class="search-activity-results padding-top-xs-2"
					v-if="searchResults.length || searchQuery.length > 0"
				>
					<p
						v-if="
							!searchResults.length &&
							searchQuery.length >= minimumQueryLength
						"
					>
						Vi kunde inte hitta några bokningsbara tjänster som
						matchar din sökning.
					</p>
					<p
						v-if="
							!searchResults.length &&
							searchQuery.length &&
							searchQuery.length < minimumQueryLength
						"
					>
						Skriv minst {{ minimumQueryLength }} tecken för att söka
						efter en tjänst.
					</p>
					<div v-if="searchResults.length">
						<ul
							class="nk-list nk-list-two-columns-md fade-on-hover"
						>
							<li
								v-for="activity in searchResults"
								:key="activity.id"
							>
								<a
									href="#"
									class="force-icon-right"
									@click="handleSelectActivity(activity)"
								>
									<span v-html="activity.activity_name"></span
								></a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
	components: {},
	data() {
		return {
			searchQuery: "",
			searchResults: [],
			minimumQueryLength: 3,
		};
	},
	computed: {
		...mapState(["activities", "activityGroups"]),
		...mapGetters(["loading"]),
	},
	methods: {
		...mapActions([
			"setActivity",
			"setModalState",
			"setActivityGroupFromSearchResult",
		]),
		clearSearchQuery() {
			this.searchQuery = "";
			this.searchResults = [];
		},
		handleSelectActivity(activity) {
			/* Don't let the user set the activity if we're loading times because this messes up the UI */
			if (this.loading.times) {
				return;
			}
			/* If a BankID sign is currently in progress, don't let the user select a new activity */
			if (this.loading.doingBooking) {
				return;
			}

			this.searchQuery = activity.activity_name;
			this.handleActivitySearch();
			this.setActivity(activity);

			/* Also set the activity group to make the UI work the same as when a user selects the activity group first and then selects the individual activity */
			for (let i in this.activityGroups.available) {
				if (
					this.activityGroups.available[i].activity_group_id ==
					activity.activity_group_id
				) {
					this.setActivityGroupFromSearchResult(
						this.activityGroups.available[i]
					);
					break;
				}
			}

			/* Set the modal state to 3 to make the calendar modal show on mobile */
			this.setModalState(3);
		},
		handleActivitySearch() {
			let results = [];
			let searchQuery = this.searchQuery.toLowerCase();
			/* Only do the search if the query is longer than x characters */
			if (searchQuery.length >= this.minimumQueryLength) {
				for (let i in this.activities.available) {
					let activity = this.activities.available[i];
					let activityName = activity.activity_name.toLowerCase();
					if (activityName.includes(searchQuery)) {
						results.push(activity);
					}
				}
			}
			this.searchResults = results;
		},
	},
};
</script>